import { useState, useCallback } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface UseConfirmAmountMismatchProps {
  amountToBePaid: number;
  totalAmount: number;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const useConfirmAmountMismatch = ({
  amountToBePaid,
  totalAmount,
  onConfirm,
  onCancel,
}: UseConfirmAmountMismatchProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = useCallback(() => {
    onConfirm();
    setIsOpen(false);
  }, [onConfirm]);

  const handleCancel = useCallback(() => {
    onCancel?.();
    setIsOpen(false);
  }, [onCancel]);

  const checkAndConfirmAmountMismatch = useCallback(
    (newAmountToBePaid: number, newTotalAmount: number) => {
      if (newAmountToBePaid !== newTotalAmount) {
        setIsOpen(true);
        return false;
      }
      return true;
    },
    []
  );

  const ConfirmDialog = useCallback(() => {
    return (
      <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
        <AlertDialogContent className="luxury-dialog">
          <AlertDialogHeader className="luxury-header">
            <AlertDialogTitle className="luxury-title">
              Xác nhận số tiền thanh toán
            </AlertDialogTitle>
          </AlertDialogHeader>
          <div className="space-y-6">
            <div className="luxury-card">
              <div className="space-y-4">
                <p className="text-center text-lg">
                  Số tiền phải trả ({amountToBePaid.toLocaleString('vi-VN')}{' '}
                  VNĐ) không khớp với tổng tiền đơn hàng (
                  {totalAmount.toLocaleString('vi-VN')} VNĐ).
                </p>
                <p className="text-center text-sm text-gray-600">
                  Bạn có chắc chắn muốn tiếp tục lưu thông tin này không?
                </p>
              </div>
            </div>
          </div>
          <AlertDialogFooter className="mt-6 space-x-4">
            <AlertDialogCancel
              onClick={handleCancel}
              className="w-[120px] luxury-button-outline"
            >
              Hủy
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirm}
              className="w-[120px] luxury-button-primary transition-colors"
            >
              Xác nhận
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    );
  }, [isOpen, amountToBePaid, totalAmount, handleConfirm, handleCancel]);

  return {
    checkAndConfirmAmountMismatch,
    ConfirmDialog,
  };
};
